import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const FutureLivestockChangeCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const { t } = useTranslation('@cibo/landmanager/FutureLivestockChangeEditor')
  const detail = params.row.findDetail({ traitId, year })
  const input = detail?.input

  if (input?.headcount) {
    return (
      <Stack>
        <Typography variant="body1">{t(input.livestockChange)}</Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {input.headcount}
          {t('perAc')}
        </Typography>
      </Stack>
    )
  }

  return input?.livestockChange ? (
    <Typography>{t(input.livestockChange)}</Typography>
  ) : (
    (null as any)
  )
}
